<template>
  <div>
         <stepheader :step="step"/>
        <div id="wizard2-p-0" role="tabpanel" aria-labelledby="wizard2-h-0" class="body current" aria-hidden="false" style="">
          <div class="row">
           <div class="col-md-6">
           <label class="form-label" for="telefono">Telefono: *</label>
              <input type="text" id="telefono"  v-model="indirizzo.telefono" class="form-control "/>
            </div>
             <div class="col-md-6">
           <label class="form-label" for="email">Email:</label>
              <input type="text" id="email"  v-model="indirizzo.email" class="form-control "/>
            </div>
             <div class="col-md-6">
           <label class="form-label" for="referente">Referente:</label>
              <input type="text" id="referente"  v-model="indirizzo.referente" class="form-control "/>
            </div>
          </div>
   
          <buttons :buttons=step.buttons v-on:action="fireaction"></buttons>
											
 
  </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import axios from "axios";
export default {
  name: "infocorriere",

  props: {
    step: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  ticket: {
      type: Object,
      required: false,
    },
    code: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      indirizzo:null
    };
  },
  computed: {
   
  },
  components: {
   
  },
  mounted() {
     this.indirizzo = this.ticket.logistica.filter(x=>x.tipologia=="riconsegna")[0];
  },
  methods: {
    fireaction:function(action,nextstep){
      switch(action){
        case "next":
           var validPhoneRegex = /^[0-9]{1,}$/;
           if(!this.indirizzo.email.match(/(?:[a-z0-9+!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/gi)){
         swal({
              title: "Errore di compilazione",
              text: "Inserire un'indirizzo email valido",
              type: "error",
              showCancelButton: false,
              toast: false,
               timer: 2000, 
              showConfirmButton: false,
              position: "bottom-top",
            });

           }else if(!this.indirizzo.telefono.match(validPhoneRegex)){
         swal({
              title: "Errore di compilazione",
              text: "Inserire un numero di telefono valido",
              type: "error",
              showCancelButton: false,
              toast: false,
               timer: 2000, 
              showConfirmButton: false,
              position: "bottom-top",
            });

           }
           else{
  this.$emit("goto",nextstep);

           }
          break;
default:
   this.$emit("goto",nextstep);
  break;
      }

    },
   loaddata: function () {
    
    },

    authenticate:function(nextstep){

    }
  },
};
</script>